
import React, {Component} from "react";
import Nav from '../../components/nav/Nav';

import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import datepicker from 'js-datepicker';

import $ from 'jquery';

import {
    Alert,
} from 'reactstrap';

import {
    getForm,
    resetForm,
    create,
    createResponse
} from '../../actions/task';

import {
    form as formService,
    create as createTask
} from '../../services/task';

import Spinner from '../../components/spinner/Spinner';

import 'js-datepicker/datepicker.css';

import '../../libraries/clock/clockpicker.css';
import env from '../../env';

/**
 * Jquery? really? Well, it had to be used to deal with the form
 * received from server. Ideally, should be a form based on inputs from server
 */
class TaskForm  extends Component{

    constructor(){
        super();

        this.state = {
            loading : true,
            form : null,
            error: null,
            creating: false,
            task_name: null,
            type: null,
            due_date: null,
            description: null,
            comment: null,
            priority_id: null,
            assigned_to: null,
            created: false
        };

        this.submitForm = this.submitForm.bind(this);
    }

    componentWillReceiveProps(nextProps){

        const {loading, form, error, creating, created} = nextProps.task;

        this.setState({loading, form, error, creating});

        if(creating){
            this.setState({created: false});
        }else{
            this.setState({created});
        }

        if(created || error)
            window.scrollTo(0, 0);

        if(form){
            $('.form-holder').html(form);
            this.initDatePicker();
        }

    }

    componentDidMount(){

        const {loggedIn} = this.props.account;

        if(!loggedIn){
            this.props.history.push(`${env.url}/login`);
        }


        const id = this.props.account.site? this.props.account.site.id: null;
        this.setState({loading: true, created: false});

        if(id && !isNaN(id)){

            let props = this.props;

           props.resetForm();

            formService({id}).then(function(resp){
                props.getForm(resp)

            }).catch(function(e){
                console.log(e);
            });

        }else{
            this.props.history.push(`${env.url}/`);
        }


       this.initJquery(this.props);
    }

    navigateHome = () => {
        this.props.history.push(`${env.url}/`);
    };

    submitForm(formData){

        let task_name = $(document).find('input[name="task_form[task_name]"]').val();
        let priority_id = $(document).find('select[name="task_form[priority_id]"]').val();
        let due_date = $(document).find('input[name="task_form[due_date]"]').val();
        let assigned_to = $(document).find('select[name="task_form[assigned_to]"]').val();
        let type = $(document).find('select[name="task_form[type]"]').val();
        let description = $(document).find('textarea[name="task_form[task_description]"]').val();
        let mine_id = $(document).find('input[name="task_form[mine_id]"]').val();

        if(task_name &&
            priority_id &&
            due_date &&
            assigned_to && type &&
            formData){

            let error = null;
            let props = this.props;

            props.create();

            let date = new Date(due_date);

            let month = date.getMonth() + 1;
            month = month < 10? `0${month}`: month;

            let day = date.getDate();
            day = day < 10? `0${day}`: day;

            due_date = `${date.getFullYear()}-${month}-${day} 00:00:00`;

            formData.append('due_date', due_date);
            formData.append('task_name', task_name);
            formData.append('priority_id', priority_id);
            formData.append('assigned_to', assigned_to);
            formData.append('type', type);
            formData.append('task_description', description);
            formData.append('mine_id', mine_id);

            let creating = true;

            createTask(formData).then(function(resp){
                props.createResponse(resp);

            }).catch(function(e){
                error = 'Connection error!';
                creating = false;
                console.log(e);
            });

            this.setState({error});

            if(!creating){
                this.setState({creating});
            }

        }else{
            this.setState({ error : 'Please fill in all required fields!'});
        }

    };

    initDatePicker(){

        if($(document).find('.datepicker').length > 0){
            datepicker(document.querySelector('.datepicker'), {
                position: 'c',
                startDate: new Date(),
                startDay: 1,
                dateSelected: new Date(),
                minDate: new Date(2016, 5, 1),
                maxDate: new Date(2099, 0, 1),
                noWeekends: false,
                customMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                customDays: ['S', 'M', 'T', 'W', 'Th', 'F', 'S'],
                overlayPlaceholder: 'Enter a 4-digit year',
                overlayButton: 'Select!',
                disableMobile: false
            });

        }

    };

    initJquery(props){

        let submit = this.submitForm;
        let home = this.navigateHome;

        $(document).on('click','form .btn-default', function(){
            props.history.push('/');
        });

        $(document).on('click', 'form .btn-success', function(e){
            e.preventDefault();

            let form = $('form')[0];
            let formData = false;

            //Fix issue with Safari when file is empty
            for (let i = 0; i < form.elements.length; i++) {
                if (form.elements[i].type === 'file') {
                    if (form.elements[i].value === '') {
                        form.elements[i].parentNode.removeChild(form.elements[i]);
                    }
                }
            }

            if (window.FormData){
                formData = new FormData(form);
            }

            submit(formData);
        });

        $(document).on('click', 'button[type="reset"]', function(e){
            e.stopPropagation();
            e.preventDefault();

            home();
        })
    };


    render(){

        const {loading,
                error,
                created,
                creating} = this.state;

        return(
            <div className="incident">

                {
                    creating?
                        <Spinner
                            message="Submitting report"
                            overlay={true}/>:null
                }


                <Nav
                    location={this.props.location}
                    history={this.props.history}/>

                {
                    created?
                        <Alert color="success">New task successfully created!</Alert>: null
                }

                {
                    loading?
                        (
                            <Spinner/>

                        ):
                        (
                            error?
                                <Alert color="danger">{error}</Alert>
                                :
                                null
                        )

                }

                <div className="form-holder" style={{padding: 30}}/>

            </div>
        )
    }
}


const mapStateToProps = ({ account, task }) => ({
    account,
    task

});

const mapDispatchToProps = dispatch => bindActionCreators({
    getForm: (data) => getForm(data),
    resetForm: () => resetForm(),
    create: () => create(),
    createResponse: (resp) => createResponse(resp)
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TaskForm)



// WEBPACK FOOTER //
// ./src/screens/task/Form.js